<template>
  <v-content>
    <v-container>
      <list
        ref="list"
        :title="title"
        :headers="headers"
        :data="data"
        :response="response"
        :can-user-delete="canUserDelete"
        :show-add-new="!isInternalPartner"
        :loading="loading"
        @edit="editFn"
        @delete="deleteFn"
        @details="previewFn"
        @new="newFn"
        @reload="loadDealers()"
        @sort="loadDealers()"
        @hook:mounted="handleMount('list')"
      >
        <template v-slot:select-headers>
          <filter-menu
            ref="filterMenu"
            :headers="headerOptions"
            :filters="filterOptions"
            :menu="filterMenu"
            :show-filter-options="true"
            location="dealers"
            @close="handleCloseFilterMenu"
            @update:headers="handleUpdateHeaders"
            @update:filters="handleUpdateFilters"
            @hook:mounted="handleMount('filterMenu')"
          ></filter-menu> </template
      ></list>
      <delete-dialog
        :dialog="deleteDialog"
        :item="itemName"
        @agree="remove"
        v-show="false"
      />
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import List from "@/components/lists/BuilderList.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import snackbar from "@/utils/snackbar.js";
import FilterMenu from "@/components/general/FilterMenu.vue";
import restrictions from "../../utils/restrictions";

export default {
  components: {
    List,
    DeleteDialog,
    FilterMenu,
  },
  data: () => ({
    mounted: {
      filterMenu: { mounted: false, refs: "filterMenu" },
      list: { mounted: false, refs: "list" },
      root: { mounted: false, refs: null },
    },
    filterMenu: false,
    filterOptions: {
      title: "",
      items: [{ title: "", options: [{ text: "", value: "" }] }],
    },
    headerOptions: [],
    headers: [],
    data: [],
    sort: "name",
    title: "Partners",
    response: null,
    loading: true,
    itemName: null,
    deleteDialog: false,
    canUserDelete: true,
  }),
  created() {
    this.setInitalData();
  },

  mounted() {
    //NOTE: this is here to prevent multiple API calls to the same function. To gether all the parameters from the different components.    this.mounted = true;
    this.handleMount("root");
  },

  computed: {
    isInternalPartner() {
      return (
        typeof this.$route.query.my_account !== "undefined" &&
        this.$route.query.my_account
      );
    },
  },
  methods: {
    handleMount(componentName) {
      if (!this.mounted.hasOwnProperty(componentName)) {
        console.error("DEALERS:component name does not exists", componentName);
        return;
      }

      this.mounted[componentName] = {
        ...this.mounted[componentName],
        mounted: true,
      };

      if (Object.values(this.mounted).every((item) => item.mounted)) {
        this.loadDealers();
      }
    },
    loadDealers() {
      let params = {};

      for (const key in this.mounted) {
        const refs = this.mounted[key].refs;
        if (refs == null) continue;
        params = {
          ...params,
          ...this.$refs[refs].query,
        };
      }

      this.$router.replace({
        name: this.$route.name,
        query: params,
      });

      this.loading = true;
      this.data = [];
      api.getDealerList(params).then((resp) => {
        this.setHeaders();
        this.response = resp.data;
        this.data = resp.data.results;
        this.title = this.isInternalPartner
          ? this.$t("users.dealers.account")
          : this.$t("users.dealers.partners");
        if (resp.data.results.length === 1 && this.isInternalPartner) {
          this.editFn(resp.data.results[0], { single: true });
          return;
        }
        this.loading = false;
      });
    },

    setInitalData() {
      this.filterOptions = {
        title: this.$t("users.dealers.filterPartnersBy"),
        items: [
          {
            title: this.$t("users.dealers.affiliationType"),
            is_hidden: false,
            options: [
              {
                text: this.$t("users.dealers.all"),
                value: "all",
                active: true,
                default: true,
                server: { name: "show", value: "all" },
              },
              {
                text: this.$t("users.dealers.master"),
                value: "masters",
                active: false,
                default: false,
                server: { name: "show", value: "masters" },
              },
              {
                text: this.$t("users.dealers.affiliate"),
                value: "affiliates",
                active: false,
                default: true,
                server: { name: "show", value: "affiliates" },
              },
            ],
          },
        ],
      };
      this.headerOptions = [
        {
          text: this.$t("users.dealers.name"),
          align: "left",
          sortable: false,
          value: "name",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.brands"),
          align: "left",
          orderingName: "brands",
          value: "brands",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.licence"),
          align: "left",
          orderingName: "licence_type",
          value: "licence_type",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.users"),
          align: "left",
          orderingName: "user_count",
          value: "user_count",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.country"),
          align: "left",
          orderingName: "country",
          value: "country",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.city"),
          align: "left",
          orderingName: "city",
          value: "city",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.affiliationType"),
          align: "left",
          value: "parent_relation",
          canHide: true,
          sortable: false,
        },
        {
          text: this.$t("users.dealers.actions"),
          align: "right",
          value: "action",
          sortable: false,
          canHide: false,
        },
      ];

      if (!restrictions.canUseCrmFeature("has_licencing_enabled")) {
        const index = this.headerOptions.findIndex((header) => {
          return header.value === "licence_type";
        });
        this.headerOptions.splice(index, 1);
      }

      this.title = this.$t("users.dealers.partners");
    },
    setHeaders() {
      if (this.isInternalPartner) {
        let index = this.headers.findIndex((header) => {
          return header.value === "brands";
        });

        if (index) {
          this.headers.splice(index, 1);
        }
      }
    },

    handleCloseFilterMenu(value) {
      this.filterMenu = value;
    },

    handleUpdateFilters() {
      if (this.$refs.list == null) return;
      this.$refs.list.setPage(1);
      this.loadDealers();
    },

    handleUpdateHeaders(headers, menu = true) {
      this.headers = this.headerOptions.filter((item) => {
        return headers.includes(item.value) || !item.canHide;
      });
      this.filterMenu = menu;
    },

    editFn(dealer, query) {
      if (
        typeof this.$route.query.my_account !== "undefined" &&
        this.$route.query.my_account === "true"
      ) {
        this.$router.push({
          name: "partnerEdit",
          params: { id: dealer.uuid },
          query: { ...this.$route.query, ...query },
        });
      } else {
        this.$router.push({
          name: "dealerEdit",
          params: { id: dealer.uuid },
          query: { ...this.$route.query, ...query },
        });
      }
    },
    deleteFn(item) {
      this.deleteDialog = true;
      this.item = item;
      this.itemName = item.name;
    },
    remove(agreed) {
      if (agreed) {
        api.deleteDealer(this.item.uuid).then((resp) => {
          snackbar.success(
            this.$t("utils.snackbar.success.successfullyDeleted")
          );
          this.loadDealers();
        });
      }
      this.deleteDialog = false;
    },
    previewFn(dealer) {
      if (
        typeof this.$route.query.my_account !== "undefined" &&
        this.$route.query.my_account === "true"
      ) {
        this.$router.push({
          name: "partnerDetails",
          params: { id: dealer.uuid },
          query: this.$route.query,
        });
      } else {
        this.$router.push({
          name: "dealerDetails",
          params: { id: dealer.uuid },
          query: this.$route.query,
        });
      }
    },
    newFn(item) {
      if (
        typeof this.$route.query.my_account !== "undefined" &&
        this.$route.query.my_account === "true"
      ) {
        this.$router.push({
          name: "partnerNew",
          query: this.$route.query,
        });
      } else {
        this.$router.push({
          name: "dealerNew",
          query: this.$route.query,
        });
      }
    },
  },
};
</script>
